/**
 * The Class Creator's To do list (Design's sketch "the split", Nino's go 27 Oct): each piece of
 * work once, with why it needs work; waiting for review first, the oldest first.
 */
import { classStatusOf, type ClassRow } from '@/lib/classStatus';
import { daysAgo } from '@/lib/facilitators';
import type { PendingContentItem } from '@/types/command-centre';

type Why = 'review' | 'draft';
export interface WorkItem { key: string; why: Why; title: string; kind: 'Class' | 'Skill drill'; note: string; href: string }

export interface DrillRow { id?: string; draft_id?: string; title?: string; status?: string; updated_at?: string; selected_skills?: string[]; skills?: string[] }

const edited = (iso?: string | null) => (iso ? `edited ${daysAgo(iso)}` : '');
const skillOf = (skills?: string[]) => (skills && skills[0] ? skills[0] : '');
export const line = (...parts: string[]) => parts.filter(Boolean).join(' · ');

/** Each piece of work once: waiting for review wins over draft. */
export function workList(pending: PendingContentItem[], classes: ClassRow[], drills: DrillRow[]): WorkItem[] {
  const out: WorkItem[] = [];
  const seen = new Set<string>();
  // The oldest waiting for review first (Design's check, 27 Oct); no date goes last.
  const byAge = [...pending].sort((a, b) => (a.submitted_at || '9999').localeCompare(b.submitted_at || '9999'));
  for (const p of byAge) {
    const id = p.micro_class_id || p.content_id;
    if (seen.has(id)) continue;
    seen.add(id);
    out.push({ key: `r:${id}`, why: 'review', title: p.title || 'Untitled', kind: 'Class', note: line(skillOf(p.skills), p.submitted_at ? `sent ${daysAgo(p.submitted_at)}` : ''), href: '/command-centre/catalogue' });
  }
  for (const c of classes) {
    if (c.status === 'published' || seen.has(c.id) || classStatusOf(c) !== 'draft') continue;
    seen.add(c.id);
    out.push({ key: `c:${c.id}`, why: 'draft', title: c.title || 'Untitled', kind: 'Class', note: line(skillOf(c.skills_assessed ?? c.skills), edited(c.updated_at)), href: '/micro-class-builder/library' });
  }
  for (const d of drills) {
    const id = String(d.id ?? d.draft_id ?? '');
    if (!id || seen.has(id) || !(d.status === 'draft' || d.status === 'needs-revision' || !d.status)) continue;
    seen.add(id);
    out.push({ key: `d:${id}`, why: 'draft', title: d.title || 'Untitled', kind: 'Skill drill', note: line(skillOf(d.selected_skills ?? d.skills), edited(d.updated_at)), href: '/workshop-builder/library' });
  }
  return out;
}
